export default __webpack_public_path__ + "static/media/closeIcon.ae11862b.svg";